module.exports = __webpack_public_path__ + "static/media/tutorial-dashboard2-step3.b54e96f5.png";